import React, { createRef, useEffect, useState } from "react";

export interface FieldContainerProps {
  children: React.ReactElement;
  elementID: string;
  elementIDToAvoid: string;
}

const calculateElementHeight = (
  container: HTMLDivElement | null,
  elementIDToAvoid: string
) => {
  const avoidedElement = document.getElementById(elementIDToAvoid);
  const containerOffset = container?.offsetTop;
  const avoidedElementOffset = avoidedElement?.offsetTop;

  let totalHeight = `100%`;
  if (avoidedElementOffset && containerOffset) {
    const height = avoidedElementOffset - containerOffset;
    totalHeight = `${height}px`;
  }

  return totalHeight;
};

export const FieldContainer: React.FC<FieldContainerProps> = ({
  children,
  elementID,
  elementIDToAvoid,
}) => {
  const containerRef = createRef<HTMLDivElement>();
  const [containerHeight, setContainerHeight] = useState("100%");
  const elementToAvoidOffset =
    document.getElementById(elementIDToAvoid)?.offsetTop;

  useEffect(() => {
    const elementHeight = calculateElementHeight(
      containerRef.current,
      elementIDToAvoid
    );
    setContainerHeight(elementHeight);
  }, [elementIDToAvoid, containerRef, elementToAvoidOffset]);

  useEffect(() => {
    const onWindowResize = () => {
      const elementHeight = calculateElementHeight(
        containerRef.current,
        elementIDToAvoid
      );
      setContainerHeight(elementHeight);
    };

    window.addEventListener("resize", onWindowResize);
    return () => window.removeEventListener("resize", onWindowResize);
  });

  return (
    <div
      ref={containerRef}
      id={elementID}
      style={{
        height: containerHeight,
        overflowY: "auto",
      }}
    >
      {children}
    </div>
  );
};
